import React from 'react'
import PropTypes from 'prop-types'
import ContactPage from '@mui/icons-material/ContactPage'

const ContactPageIcon = ({ height, width, ...more }) => {
	
	return (
		<ContactPage
			height={height}
			width={width}
			{...more}
		/>
	)
}

ContactPageIcon.propTypes = {
	height: PropTypes.number.isRequired,
	width: PropTypes.number.isRequired
}

export default ContactPageIcon
